import { ReactNode } from 'react';
import cl from 'classnames';

import { IconsEnum } from '../../../../../../assets/icons/types';
import { Icon } from '../../../../../../helpers/Icon';

interface DisplaySettingsMenuItemProps {
  icon?: IconsEnum;
  label: ReactNode;
  onClick?: () => void;
  currentValue?: ReactNode;
  withChevron?: boolean;
  selected?: boolean;
  toggle?: boolean;
  checked?: boolean;
}

function DisplaySettingsMenuItem({
  icon,
  label,
  onClick,
  currentValue,
  withChevron,
  selected,
  toggle,
  checked
}: DisplaySettingsMenuItemProps) {
  return (
    <button
      type="button"
      className="px-1 block w-full group/menu-item"
      role="menuitem"
      onClick={onClick}
    >
      <div className="px-2 py-1 dark:group-hover/menu-item:bg-gray-800 group-hover/menu-item:bg-gray-100 rounded min-h-7">
        <div className="flex items-center gap-2 text-md sm:text-sm">
          {icon && <Icon className="h-5 w-5" icon={icon} />}
          <span className="mr-auto font-normal sm:font-medium block truncate leading-5 text-left">
            {label}
          </span>
          {currentValue != null && (
            <span className="italic text-2xs text-gray-500">
              {currentValue}
            </span>
          )}
          {withChevron && (
            <Icon className="w-4 h-4" icon={IconsEnum.CHEVRON_RIGHT} />
          )}
          {selected && (
            <Icon className="h-5 w-5 text-blue-600" icon={IconsEnum.CHECK} />
          )}
          {toggle && (
            <span
              className={cl(
                'relative inline-flex w-9 h-5 shrink-0 rounded-full p-0.5 ring-1 ring-inset ring-gray-900/5 transition-colors duration-200 ease-in-out dark:ring-white/10',
                checked ? 'bg-blue-600' : 'bg-gray-200 dark:bg-white/5'
              )}
            >
              <span
                className={cl(
                  'size-4 rounded-full bg-white shadow-sm ring-1 ring-gray-900/5 transition-transform duration-150 ease-in-out',
                  checked && 'translate-x-4'
                )}
              />
            </span>
          )}
        </div>
      </div>
    </button>
  );
}

export default DisplaySettingsMenuItem;
